'use client';

import { LazyLottie } from './LazyLottie';
import { IAnimationProps } from './types';

export function LoaderRetailApp(props: IAnimationProps) {
  const loadAnimation = () => import('./raw-json/loader-retail-app.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="LoaderRetailApp"
    />
  );
}
